export class Concept {
  id= null;
  code= null;
  name= null;
  definition= null;
  references= []
}
export class UpdatedConcept {
  changes_type=null;
	items=[];
}
export default class ConceptSubmission {
  code=null;
  name=null;
  definition=null;
  references=[''];
  updated_concept= null;
}
